import React, { useState, useEffect } from "react";
import { useTranslation } from "i18n";

export interface ExpandableFileNameProps {
  fileName: string | null | undefined;
  fileNameLength?: number;
  spanClassName: string;
  spanExpandedClassName?: string;
  toggleClassName: string;
}

export function ExpandableFileName({
  fileName,
  fileNameLength,
  spanClassName,
  spanExpandedClassName,
  toggleClassName,
}: ExpandableFileNameProps): React.ReactElement | null {
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    setIsExpanded(false);
  }, [fileName]);

  if (!fileName) return null;

  if (!fileNameLength || fileName.length <= fileNameLength) {
    return <span className={spanClassName}>{fileName}</span>;
  }

  const handleExpand = () => {
    setIsExpanded(true);
  };

  const handleCollapse = () => {
    setIsExpanded(false);
  };

  if (isExpanded) {
    return (
      <span className={spanExpandedClassName ?? spanClassName}>
        {fileName}{" "}
        <button
          type="button"
          aria-expanded={isExpanded}
          onClick={handleCollapse}
          className={toggleClassName}
        >
          {t("common:button.label.less")}
        </button>
      </span>
    );
  }

  return (
    <span className={spanClassName}>
      {fileName.slice(0, fileNameLength)}...{" "}
      <button
        type="button"
        aria-expanded={isExpanded}
        onClick={handleExpand}
        className={toggleClassName}
      >
        {t("common:button.label.more.lower")}
      </button>
    </span>
  );
}
